/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Blob_Save_Dialog_Step_DestinationInputs */



/**
* | output |
* | --- |
* | "Choose where to save this file." |
*
* @param {Chat_Blob_Save_Dialog_Step_DestinationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_blob_save_dialog_step_destination = /** @type {((inputs?: Chat_Blob_Save_Dialog_Step_DestinationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Blob_Save_Dialog_Step_DestinationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie aus, wo die Datei gespeichert werden soll.")
	return /** @type {LocalizedString} */ ("Choose where to save this file.")
});